import { IApplicationState } from '../../types/redux';

export function getVideos(state: IApplicationState) {
  return state.newbuilding.videos;
}
